// frontend/src/components/ConversationAssistant.js
import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import apiClient from '../../utils/apiClient';

function ConversationAssistant({ nodes, onNodeSelect }) {
  const { t, i18n } = useTranslation();
  const [messages, setMessages] = useState([]);
  const [userInput, setUserInput] = useState('');
  const [loading, setLoading] = useState(false);
  const messagesEndRef = useRef(null);
  // Scroll automatique vers le bas
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }
  
  useEffect(scrollToBottom, [messages]);

  const handleSendMessage = async () => {
    if (!userInput.trim()) return;
    
    const newMessage = { role: 'user', content: userInput };
    setMessages(prev => [...prev, newMessage]);
    setUserInput('');
    setLoading(true);
    
    try {
      const response = await apiClient.post('/assistant/chat', {
        query: userInput,
        history: messages,
        lang: i18n.language
      });
      
      setMessages(prev => [...prev, { 
        role: 'assistant', 
        content: response.data.answer,
        references: response.data.references || []
      }]);
    } catch (error) {
      setMessages(prev => [...prev, { 
        role: 'assistant', 
        content: t('conversationAssistant.errors.requestError'),
        error: true
      }]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="conversation-container">
      <div className="messages-container">
        {messages.map((msg, idx) => (
          <div key={idx} className={`message ${msg.role}`}>
            {msg.role === 'user' ? '👤' : '🤖'}
            <div className="message-content">
              {msg.content}
              
              {msg.references && msg.references.length > 0 && (
                <div className="references">
                  <h4>{t('conversationAssistant.references')}:</h4>
                  <ul>
                    {msg.references.map((ref, i) => (
                      <li key={i} onClick={() => onNodeSelect(ref.name)}>
                        {ref.name} ({ref.similarity.toFixed(2)})
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div>
        ))}
        {loading && <div className="message assistant loading">🤖 {t('conversationAssistant.thinking')}</div>}
        <div ref={messagesEndRef} />
      </div>
      
      <div className="input-container">
        <input
          type="text"
          value={userInput}
          onChange={(e) => setUserInput(e.target.value)}
          placeholder={t('conversationAssistant.placeholder')}
          onKeyPress={(e) => e.key === 'Enter' && handleSendMessage()}
        />
        <button onClick={handleSendMessage} disabled={loading || !userInput.trim()}>
          {loading ? "⏳" : "📤"}
        </button>
      </div>
    </div>
  );
}

export default ConversationAssistant;